import { render, staticRenderFns } from "./HomeShadow.vue?vue&type=template&id=72e4d179&scoped=true&"
import script from "./HomeShadow.vue?vue&type=script&lang=js&"
export * from "./HomeShadow.vue?vue&type=script&lang=js&"
import style0 from "./HomeShadow.vue?vue&type=style&index=0&id=72e4d179&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e4d179",
  null
  
)

export default component.exports